import React from 'react'
import Link from './link.js'
import { cn } from '../helpers/utils.js'
import { Container } from './container.js'

type BrandStripItem = {
  /** 品牌名称，用于默认展示和辅助文本 */
  name: string
  /** 品牌 Logo 的图片地址，默认是内置的文字 Logo */
  logo?: string
  /** 自定义 alt 文案 */
  alt?: string
  /** 跳转链接，可选 */
  link?: string
}

type BrandStripProps = {
  data: any
  /** 外层容器 class */
  className?: string
  /** 每个卡片的 class */
  itemClassName?: string
}

/**
 * BrandStrip - 品牌徽标展示条
 *
 * @description 展示品牌 Logo 列表的组件，支持自定义标题、Logo 和跳转链接
 */
const BrandStrip: React.FC<BrandStripProps> = ({ data, className, itemClassName }) => {
  return (
    <div className={cn('w-full', className)}>
      <Container className="!bg-transparent">
        {data?.title ? (
          <p
            className="brand-strip-title mb-2 text-sm font-bold text-[#767880]"
            dangerouslySetInnerHTML={{ __html: data?.title || '' }}
          />
        ) : null}
        <div className="flex flex-wrap gap-2">
          {data?.leftIcon?.map?.((item: any, index: number) => {
            return (
              <Link key={index} href={item?.link} asChild={!item?.link} className="desktop:hidden block h-full">
                <div
                  dangerouslySetInnerHTML={{ __html: item?.logo || '' }}
                  className={cn(
                    'brand-strip-item rounded-sidebar-shelf box-border flex h-fit items-center justify-center bg-[#F5F6F7] px-4 py-2 [&_svg]:h-full [&_svg]:w-auto [&_svg_path]:[fill:#080A0F]',
                    itemClassName
                  )}
                />
              </Link>
            )
          })}
        </div>
      </Container>
    </div>
  )
}

export type { BrandStripProps, BrandStripItem }
export default BrandStrip
